<template>
    <div class="new_content"> 
        <div class="flex_spw cont_heard " >
            <Button @click="seeJHM()" style="background:#FF761D;color:#fff;border-color:#FF761D">创建</Button>
            <div class="flex_sta">
                <div style="margin-right:16px">
                    <div>
                        <Input v-model="pageForm.activation_code" placeholder="请输入激活码" style="width: auto" @on-enter="goSearch()">
                        <Icon type="ios-search" slot="suffix" /></Input>
                    </div>
                </div>
                <div>
                    <Button @click="goSearch()" style="background:#FF761D;color:#fff;border-color:#FF761D">搜索</Button>
                </div>
            </div>
        </div>
        <!-- @on-selection-change="chooseData" -->
        <div class="cont_tab">
            <Table :columns="columns12" :data="data6" :loading="loadingone">
                <template slot-scope="{ index }" slot="index">
                    <strong>{{ index+1 }}</strong>
                </template>
                <template slot-scope="{ row }" slot="activation_code">
                    <div class="shubiao" @click="copyText(row.activation_code)">
                    {{ row.activation_code }}                    
                    </div>
                </template>
                <template slot-scope="{ row }" slot="plugin_package">
                    <div>{{ row.plugin_package?row.plugin_package.name:'' }}</div>
                </template>
                <template slot-scope="{ row }" slot="status">
                    {{ row.status == 1 ? '激活成功' : '未激活' }}
                </template>
                <template slot-scope="{ row }" slot="user_info">
                    <div v-if="row.user_info">
                        {{ row.user_info.account }}
                    </div>                
                </template>            
                <template slot-scope="{ row }" slot="type">
                    <div>
                        {{ row.type==1?'插件套餐':'产品套餐' }}
                    </div>
                </template>       
                <template slot-scope="{ row }" slot="is_prohibit">
                    <div>
                        <!-- is_prohibit   列表返回禁用状态   1是    0否 -->
                        {{ row.is_prohibit == 1?'禁用':'启用' }}
                    </div>
                </template>       
                <template slot-scope="{ row }" slot="action">
                    <Button @click="seeBtn(row)" style="color:#3C90EE;background: unset;" v-if="row.status==0" type="text">激活</Button>
                    <!-- http://192.168.1.201:118/adminapi/empower/update_order_status?activation_id=2&order_id=204&is_revoke=1 -->
                    <Button @click="deactivate(row)" style="color:#3C90EE;background: unset;" v-if="row.status==1" type="text">撤销激活</Button>
                    <Button @click="update_prohibit(row)" style="color:#12B130;background: unset;" type="text">{{ row.is_prohibit == 1 ? '启用':'禁用' }}</Button>
                    <Button @click="del_use(row)" style="color:red;background: unset;" type="text">删除</Button>
                </template>
            </Table>
            <br />
             <Page :total="total" :current="pageForm.page" @on-change="pageChange" show-total show-elevator style="text-align:right" />
        </div>
        

        <!-- 查看弹框 -->
        <Modal v-model="seemodal" :mask-closable="false" width="510">
            <p slot="header" style="text-align:center">修改账户</p>
            <div class="modal_contene ">
                <Form  label-position="left" :label-width="100">                   
                    <FormItem label="账号">
                        <Input v-model="formData.nickname"></Input>
                    </FormItem>
                    <FormItem label="密码">
                        <Input v-model="formData.wechat_num"></Input>
                    </FormItem>
                    <FormItem label="产品权限">
                        <Select filterable  transfer  v-model="formData.sex">
                            <Option v-for="item in GenderList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>                  
                    <FormItem label="启用">
                        <i-switch   :true-value="1" :false-value="0" size="large">
                            <span slot="open">开启</span>
                            <span slot="close">关闭</span>
                        </i-switch>
                    </FormItem>                   
                </Form>             
            </div>
            <!-- <div slot="footer">
                <Button @click="addBtn" class="btn">确定</Button>
            </div> -->
        </Modal>
        <Modal v-model="showAddModal" width="600" :mask-closable="false">
            <p slot="header" style="text-align:center">
                <span>{{ addModalTitle == 'add' ? '创建' : '修改' }}</span>
            </p>
            <div class="">
                <div class="form_box" style="padding-bottom: 80px;">                     
                    <div class="form_item_box" >
                        <div class="form_label" >产品:</div>
                        <div class="form_conter">
                            <Select filterable  transfer  v-model="addOrderData.application_id" style="width:300px" placeholder="请选择产品" clearable @on-change="goGetgoodsList">
                                <Option v-for="item in applicationList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                            </Select>
                        </div>
                    </div>    
                    <div class="form_item_box" >
                        <div class="form_label">套餐类型:</div>
                        <div class="form_conter">
                            <Select filterable  transfer  v-model="addOrderData.type" style="width:300px" placeholder="请选择套餐类型" clearable @on-change="goGetgoodsList">
                                <!-- <Option v-for="item in pluginTypeList" :value="item.id" :key="item.id">{{ item.name }}</Option> -->
                                <Option value="0" :disabled="addOrderData.application_id===0">产品套餐</Option>
                                <Option value="1">插件套餐</Option>
                            </Select>
                        </div>
                    </div>     
                    <div class="form_item_box" >
                        <div class="form_label">套餐:</div>
                        <div class="form_conter">
                            <Select filterable  transfer  v-model="addOrderData.package_id" style="width:300px"
                                :placeholder="((this.addOrderData.type === 0 || this.addOrderData.type === 1) && this.addOrderData.application_id) ? '请选择套餐' : '请先选择产品与套餐类型'" clearable>
                                <Option v-for="item in goodsList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                            </Select>
                        </div>
                    </div> 

                </div>
            </div>
            <div slot="footer">
                <Button @click="showAddModal = !showAddModal" >取消</Button>
                <Button @click="goAddSubmit()" style="background:#FF761D;color:#fff;border-color:#FF761D">确认</Button>                
            </div>
        </Modal>

        <!-- 下单弹框账户弹框 -->
        <Modal v-model="showOrderModal" width="600" :mask-closable="false">
            <p slot="header" style="text-align:center">
                <span>激活</span>
            </p>
            <div class="">
                <div class="form_box">
                    <div class="form_item_box" >
                        <div class="form_label">激活订单</div>
                        <div class="form_conter" >
                            <!-- orderList -->
                            <Select filterable  transfer  v-model="order_id" style="width:300px" placeholder="请选择激活订单" clearable >
                                <Option v-for="item in orderList" :value="item.id" :key="item.id">{{ item.newName }}</Option>
                            </Select>
                        </div>                        
                    </div>
                </div>
            </div>
            <div slot="footer">
                <Button @click="showOrderModal = false" >取消</Button>
                <Button @click="goActivation()" style="background:#FF761D;color:#fff;border-color:#FF761D">确认</Button>                
            </div>
        </Modal>     
    </div>
</template>

<script>
    import { copy } from 'clipboard';
    import VueClipboard from 'vue-clipboard2'
    import { authorlze_list,update_authorlze,authorlze_del,application_list,goods_list,package_orderuser,update_order_status,update_prohibit   } from "@/api/index";
    export default {     
        directives: { 'clipboard': VueClipboard },   
        data(){
            return{
                JHM:'',   
                showOrderModal:false,
                total:0,
                fkType:'weixin',
                pageForm:{
                    page:1,
                    limit:10,
                    activation_code:'',
                },
                cityList: [],
                submitData: { // 这里是需要携带的数据
                    uid:null
                },
                seemodaltitle:'激活',  // 订单详情
                addModalTitle : 'add',
                contentTexe:'',
                GenderList: [
                    {
                        value: 1,
                        label: '男'
                    },
                    {
                        value: 2,
                        label: '女'
                    }
                ],
                uid:null,
                formData:{},
                fkmodal:false,
                seetitle:'激活',
                seemodal:false,
                showAddModal:false,
                columns12: [
                    // {type: 'selection',width: 60,align: 'center'},
                    {title: '#',slot: 'index',align: 'center',},
                    {title: '激活码(点击复制)',slot: 'activation_code',align: 'center',},
                    {title: '类型',slot: 'type',align: 'center',},
                    {title: '产品名称',key: 'system_name',align: 'center',},
                    {title: '套餐名称',slot: 'plugin_package',align: 'center',},     
                    {title: '激活码状态',slot: 'status',align: 'center',},     
                    {title: '状态',slot: 'is_prohibit',align: 'center',},     
                    {title: '激活人员',slot: 'user_info',align: 'center',},    
                    {title: '激活时间',key: 'operate_time',align: 'center',},                            
                    {title: '操作',slot: 'action',width: 250,fixed: 'right',align: 'center',}
                ],
                data6: [],
                loadingone:false,
                order_id: '',
                activation_id:'',
                addOrderData: {
                    application_id: '',//	产品id 创建订单使用
                    type: '',//	0产品套餐 1插件套餐
                    package_id: '', //套餐id
                    activation_id: '',
                },
                applicationList: [],
                pluginTypeList: [
                    { id: 0, name:'产品套餐'},
                    { id: 1, name:'插件套餐'},
                ],
                goodsList: [],
                orderList: []
            }
        },
        created(){
            this.getList()

            //弹窗数组
            this.application_list()
        },
        computed: {
        },
        methods:{
            goGetgoodsList(){    
                if(this.addOrderData.application_id ===  0 && this.addOrderData.type === '0'){
                    this.addOrderData.type = ''
                    this.addOrderData.package_id = ''
                    this.goodsList = []
                }   
              
                if(  (this.addOrderData.type === '0' || this.addOrderData.type === '1') && (this.addOrderData.application_id||this.addOrderData.application_id===0)){
                    this.addOrderData.package_id = ''
                    this.goods_list()
                    return
                }else{
                    this.addOrderData.package_id = ''
                    return
                }
            },
            goods_list(){
                let newPageForm = {
                    page: 1,
                    limit: 9999,
                    type: this.addOrderData.type,            //0产品 1插件
                    application_id: this.addOrderData.application_id
                }
                goods_list(newPageForm).then(res=>{
                    this.goodsList = []
                    this.goodsList = res.data.data
                    if(this.goodsList.length == 0){
                        this.$Message.error('暂无套餐~')
                    }
                })
            },
            application_list(){
                application_list().then(res=>{
                    this.applicationList = res.data
                })
            },
            goAddSubmit(){
                if(!this.addOrderData.package_id){
                    this.$Message.error('请选择套餐')
                    return
                }
                update_authorlze(this.addOrderData).then(res=>{                    
                    this.showAddModal = false
                    this.getList()    
                    this.$Message.success(res.msg)                                       
                }).catch(err=>{
                    this.$Message.error(err.msg)
                })
            },            
            copyText(e) {
                copy(e);
                this.$Message.success('复制成功')                
            },
            goPay(){
                this.showOrderModal = false
                // this.fkmodal = true
            },
            seeJHM(){
                this.addModalTitle = 'add'
                this.reast()
                this.showAddModal = true
            },
            reast(){
                this.addOrderData.application_id = ''
                this.addOrderData.type = ''
                this.addOrderData.package_id = ''
                this.addOrderData.activation_id = ''
            },
            goSearch (){
                this.pageForm.page = 1
                this.getList()
            },
            chooseData(e){
                console.log('e',e)
            },
            goChooseType(e){
                this.fkType = e
            },
            getList(){
                this.loadingone = true  ; 
                authorlze_list(this.pageForm).then(res=>{
                    this.loadingone = false
                    this.total = res.data.total
                    this.data6 = res.data.data
                })
            },
            search(){
                this.pageForm.name = this.$store.state.searchContent
                this.getList()
            },
            package_orderuser(e){
                this.orderList = []
                let data = {
                    application_id: e.application_id,
                    package_id: e.package_id,
                    type:e.type,
                    page:1,
                    limit:9999
                }
                package_orderuser(data).then(res=>{
                    this.orderList =  res.data.data
                    this.orderList.forEach(item=>{
                        item.newName ='订单号：'+ item.order_no +'：'+item.pay_money+"元(" +item.user_info.account+')'
                    })
                    if(res.data.data.length==0){
                        this.$Message.error('暂无可激活订单')
                    }
                })
            },
            seeBtn(row){
                this.activation_id = row.id
                this.order_id = ''
                this.package_orderuser(row)
                this.showOrderModal = true
            },
            goActivation(){
                if(!this.order_id){
                    this.$Message.error('请选择订单')
                    return
                }
                update_order_status({activation_id:this.activation_id,order_id:this.order_id}).then(res=>{
                    this.$Message.success(res.msg)
                    this.getList()
                    this.showOrderModal = false
                }).catch(err=>{
                    this.$Message.error(err.msg)
                })
            },
            addBtn(){
                if (this.seetitle=='查看') {
                    this.seemodal = false
                }else{
                    this.formData.uid = this.uid
                    edit_info(this.formData).then(res=>{
                        this.$Message.success(res.msg)
                        this.getList()
                        this.seemodal = false
                    }).catch(err=>{
                        this.$Message.error(err.msg)
                    })
                }
            },
            seexqModal(){
                this.showAddModal = true
                this.addModalTitle = 'edit'
            },
            statusBtn(){
                if (this.contentTexe=='确认禁用此账户') {
                    edit_status({uid:this.uid,status:0}).then(res=>{
                        this.getList()
                        this.$Message.success(res.msg)
                        this.showAddModal = false
                    }).catch(err=>{
                        this.$Message.error(err.msg)
                    })
                }else{
                    edit_status({uid:this.uid,status:1}).then(res=>{
                        this.getList()
                        this.$Message.success(res.msg)
                        this.showAddModal = false
                    }).catch(err=>{
                        this.$Message.error(err.msg)
                    })
                }
            },
            update_prohibit(e){
                console.log('e',e)
                this.$Modal.confirm({
                title: '提示',
                content: `是否确认`+(e.is_prohibit == 1 ? '启用' : '禁用') +`该激活码`,
                    onOk: () => {
                        update_prohibit({activation_id:e.id,status:e.is_prohibit==0?1:0}).then(res=>{
                            this.$Message.success(res.msg)
                            this.getList()
                        }).catch(err=>{
                            this.$Message.error(err.msg)
                            this.getList()
                        })
                    },
                    onCancel: () => {
                    }
                });
            },   
            // http://192.168.1.201:118/adminapi/empower/update_order_status?activation_id=2&order_id=204&is_revoke=1
            deactivate(e){
                this.$Modal.confirm({
                title: '提示',
                content: `是否确认撤销激活该激活码`,
                onOk: () => {
                    update_order_status({activation_id:e.id,order_id:e.order_id,is_revoke:1}).then(res=>{
                        this.$Message.success(res.msg)
                        this.getList()
                    }).catch(err=>{
                        this.$Message.error(err.msg)
                        this.getList()
                    })
                },
                onCancel: () => {
                }
                });
            },   
          
            del_use(e){
                this.$Modal.confirm({
                title: '提示',
                content: `是否确认删除该激活码`,
                onOk: () => {
                    authorlze_del({activation_id:e.id}).then(res=>{
                        this.$Message.success(res.msg)
                        this.getList()
                    }).catch(err=>{
                        this.$Message.error(err.msg)
                        this.getList()
                    })
                },
                onCancel: () => {
                }
                });
            },            
            pageChange(e){
                this.pageForm.page = e
                this.getList()
            }
        }
    }
</script>

<style scoped>
.flex_btw{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.nochoose_box{
    width: 80px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border-top: 0.5px solid rgb(180, 180, 180);
    border-left: 0.5px solid rgb(180, 180, 180);    
    border-bottom: 0.5px solid rgb(180, 180, 180);
    cursor: pointer;
    /* border-radius: 4px; */
}
.choose_box{
    cursor: pointer;
    width: 80px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border-top: 0.5px solid rgb(180, 180, 180);
    border-left: 0.5px solid rgb(180, 180, 180);    
    border-bottom: 0.5px solid rgb(180, 180, 180);
    background: #FF761D;
    color: #fff;
}
    .modal_contene{
        /* height: 500px; */
        overflow: auto;
    }
    .user_pic_box{
        margin: 10px 0;
        width: 70px;
        height: 70px;
    }
    .flex_sta {
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .user_pic_box img{
        width: 100%;
        height: 100%;
        border-radius: 10px;
        object-fit: cover;
    }
    .Photo_wall{
        display: flex;
        align-items: center;
    }
   
    .photo_box img{
        width: 70px;
        height: 70px;
        object-fit: cover;
        border-radius: 10px;
        margin-right: 5px;
    }
    .btn{
        background: #FF761D;
        color: #0A1629;
    }
    .head_portrait{
        display: flex;
        flex-wrap: wrap;
    }
    .fk_class {
        width:300px;
    }
    .viewimg{
        position: relative;
        width: 80px;
        height: 80px;
        margin-right: 10px;
        margin-bottom: 10px;
        border-radius: 10px;
        overflow: hidden;
    }
    .viewimg img{
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .absolu_close:hover{
        opacity: 1;
    }
    .flex_cen {
        position: relative;
    }
    .san_class {
       display: flex;
       justify-content: flex-end;
       align-items: flex-end;
    }
    .absolu_close{
        cursor: pointer;
        position: absolute;
        top: 0;
        opacity: 0;
        left: 0;
        width: 80px;
        height: 80px;
        background: rgba(0,0,0,.5);
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .upload_img{
        cursor: pointer;
        width: 80px;
        height: 80px;
        border: 1px solid #eee;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
    }
    .upload_img_txt{
        margin-top: -10px;
        font-size: 12px;
        color: #999;
    }
    .just_content{
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>
<style>
    .ivu-table-header thead tr th {
        background: #fff !important;
    }
    .ivu-table-fixed-header thead tr th{
        background: #fff !important;
    }
    .ivu-table td, .ivu-table th {
        border-bottom: 1px solid #F0F6FC;
        color: #74798C;
    }
    .ivu-table:before{
        background: unset;
    }
    /* .ivu-modal-content{
        overflow: hidden;
    } */
    .ivu-modal-header{
        background: #fff;
    }
    .ivu-modal-close .ivu-icon-ios-close{
        color: #0A1629;
    }
    .ivu-modal-footer{
        border-top: unset;
    }
</style>